import App from 'App';
import 'sass/index.scss';
import renderApp from './lib/renderApp';

renderApp.withoutAuth(App);
